module.exports = __webpack_public_path__ + "img/sidebar-right.7bc19c51.svg";